import { useCallback, useContext, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ContentButton from '../../../draft-content-transplant/ContentButton';
import contentOutput from '../../editorCapabilities/ContentOutputTypes';
import { RTEToolbarButton } from '../../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../../contexts/useDebouncedEditorStateContext';
import hubHttpClient from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { insertContent } from '../../utils/documentUtils';
import { convertToPlaintextState } from '../../utils/plaintextUtils';
import ContentContainer from '../../components/insertMenu/ContentContainer';
import identity from 'transmute/identity';
import GenericPopoverHeader from '../../components/GenericPopoverHeader';
import InsertContentDecoratorV2 from '../../../draft-transplant/InsertContentDecoratorV2';
import { templatesApiWrapper } from './TemplatesApi';
import TemplatesPopoverEmptyState, { getTemplatesUrl } from './TemplatesPopoverEmptyState';
import { EditorConfigContext } from '../../contexts/EditorConfigContext';
import { getGlobalVars } from '../../utils/globalVarUtil';
import TemplatesPopoverErrorState from './TemplatesPopoverErrorState';
import { SalesTemplatesIcon } from 'foundations-assets/icons/components/SalesTemplatesIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const TemplatesButton = ({
  onClick
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "hubspot-prosemirror.tooltips.insertTemplates"
  }),
  children: /*#__PURE__*/_jsx(RTEToolbarButton, {
    onClick: onClick,
    selected: false,
    children: /*#__PURE__*/_jsx(TextToolbarIcon, {
      icon: SalesTemplatesIcon
    })
  })
});
export default function InsertTemplates({
  onInsertContent = identity,
  onOpenPopover,
  outputType = contentOutput.RENDERED,
  contactEmail,
  contactVid,
  supplementalObjects,
  renderedPopoverClassname,
  useContentContainer,
  onViewInsertMenu = () => {},
  onInsertComplete = () => {}
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const {
    usePlaintextMode,
    plaintextOptions
  } = getGlobalVars(useContext(EditorConfigContext));
  const insertTemplate = useCallback(({
    htmlBody,
    metadata
  }) => {
    const newState = insertContent({
      htmlBody,
      editorState,
      from: editorState.selection.from,
      to: editorState.selection.to
    });
    setEditorState(usePlaintextMode ? convertToPlaintextState(newState, plaintextOptions) : newState);
    onInsertComplete();
    onInsertContent(metadata);
  }, [editorState, setEditorState, usePlaintextMode, plaintextOptions, onInsertComplete, onInsertContent]);
  const TemplatesPopover = useMemo(() => {
    const apiFunctions = templatesApiWrapper(hubHttpClient);
    const insertTemplateDecoratorConfig = {
      outputType,
      apiFunctions,
      mergeTagOptions: {
        includeCustomTokens: true
      }
    };
    if (useContentContainer) {
      return InsertContentDecoratorV2(ContentContainer({
        onInsertContent: identity,
        portalId: PortalIdParser.get(),
        PopoverErrorState: TemplatesPopoverErrorState,
        PopoverEmptyState: TemplatesPopoverEmptyState,
        Header: GenericPopoverHeader,
        searchPlaceHolder: 'hubspot-prosemirror.generic.search.placeholder',
        search: apiFunctions.searchTemplates,
        onViewInsertMenu,
        manageUrl: getTemplatesUrl(),
        titleMessage: 'hubspot-prosemirror.templates.title',
        contentKey: 'templates'
      }), insertTemplateDecoratorConfig);
    }
    return InsertContentDecoratorV2(ContentButton({
      onInsertContent: identity,
      // @ts-expect-error ts-migrate FIXME
      portalId: PortalIdParser.get(),
      Button: TemplatesButton,
      PopoverErrorState: TemplatesPopoverErrorState,
      PopoverEmptyState: TemplatesPopoverEmptyState,
      onOpenPopover,
      Header: GenericPopoverHeader,
      renderedPopoverClassname,
      searchPlaceHolder: 'hubspot-prosemirror.generic.search.placeholder',
      search: apiFunctions.searchTemplates,
      popoverTestKey: 'snippets-popover',
      manageUrl: getTemplatesUrl(),
      titleMessage: 'hubspot-prosemirror.templates.title'
    }), insertTemplateDecoratorConfig);
  }, [onOpenPopover, outputType, renderedPopoverClassname, onViewInsertMenu, useContentContainer]);
  return /*#__PURE__*/_jsx(TemplatesPopover, {
    contactEmail: contactEmail
    // @ts-expect-error migration
    ,
    contactVid: contactVid,
    supplementalObjects: supplementalObjects,
    onChange: insertTemplate,
    useProsemirror: true
  });
}